var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f"},[_vm._v("Copyright©www.techlion.com.cn All Rights Reserved"),_c('br'),_vm._v("山东泰克莱恩 0513-88762550")])}]

export { render, staticRenderFns }